import { Typography } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import React, { useEffect, useState } from "react";

interface TimerCounterProps {
  startDate?: {
    start: string;
    end: string | null;
  }[]
  timeConfig?: number;
  daysReturn: boolean;
  isStart: boolean;
  timer?: boolean
}

export const TimerCounterOla = ({ startDate, daysReturn, isStart, timer, timeConfig }: TimerCounterProps) => {
  const [timeDiff, setTimeDiff] = useState(0);

  useEffect(() => {
    const calculateElapsedTime = () => {
      if (!startDate || startDate.length === 0) return 0;

      return startDate.reduce((total, { start, end }) => {
        const startTime = dayjs(start);
        const endTime = end ? dayjs(end) : dayjs();
        return total + Math.max(endTime.diff(startTime, "seconds"), 0);
      }, 0);
    };

    let initialTime = calculateElapsedTime();

    if (!isStart && timeConfig !== undefined) {
      initialTime = Math.max(timeConfig / 1000 - initialTime, 0);
    }

    setTimeDiff(initialTime);

    if (timer) {
      /* setTimeout(() => {
        setTimeDiff(prevTime => (isStart ? prevTime + 1 : Math.max(prevTime - 1, 0)));
      }, 1000 - (dayjs().millisecond())); */

      const intervalId = setInterval(() => {
        setTimeDiff(prevTime => (isStart ? prevTime + 1 : Math.max(prevTime - 1, 0)));
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [startDate, timeConfig, isStart, timer]);

  const totalHours = Math.floor(timeDiff / 3600);
  const days = Math.floor(timeDiff / 86400).toString().padStart(2, "0");
  //const hours = Math.floor((timeDiff % 86400) / 3600).toString().padStart(2, "0");
  const hours = daysReturn
  ? Math.floor((timeDiff % 86400) / 3600).toString().padStart(2, "0") // Horas normales
  : totalHours.toString().padStart(2, "0");
  const minutes = Math.floor((timeDiff % 3600) / 60).toString().padStart(2, "0");
  const seconds = (timeDiff % 60).toString().padStart(2, "0");

  return (
    <Typography color="textSecondary" sx={{ fontWeight: 'bold' }}>
      {daysReturn ? `${days} días ${hours}:${minutes}:${seconds}` : `${hours}:${minutes}:${seconds}`}
    </Typography>
  );
};